import { TextSettings } from '../types/altText';
import { API_BASE_URL, DEFAULT_HEADERS } from '../constants/apiConfig';

/**
 * Base64 이미지 URL에서 실제 인코딩된 문자열만 추출하는 함수
 * @param imageUrl Base64 형식의 이미지 URL
 * @returns Base64 문자열 부분만 반환
 */
export const extractBase64String = (imageUrl: string): string => {
  if (imageUrl.startsWith('data:image')) {
    return imageUrl.split(',')[1];
  }
  return imageUrl;
};

/**
 * 대체 텍스트 생성 함수
 * @param images 이미지 URL 배열
 * @param settings 텍스트 설정
 * @returns 생성된 대체 텍스트 배열
 */
export const generateAltText = async (
  images: string[],
  settings: TextSettings,
  postTitle?: string,
  postContent?: string,
): Promise<string[]> => {
  try {
    const processedImages = images.map((img) => extractBase64String(img));

    const results = await Promise.all(
      processedImages.map(async (imageUrl) => {
        const requestData = {
          imageUrl,
          language: settings.language,
          lines: settings.lines,
          tone: settings.tone,
          postTitle,
          postContent,
        };

        const response = await fetch(`${API_BASE_URL}/alt-text`, {
          method: 'POST',
          headers: {
            ...DEFAULT_HEADERS,
            'x-api-key': '508f8500-AITAG-ADMIN',
            'x-basic-key':
              '$2a$04$1eUpucOwr5k4/SDDCtZD1uOcQoVnTSwOxWu8ftxjudGDVbuQotMz6',
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          const errorData = await response
            .json()
            .catch(() => ({ message: '알 수 없는 오류가 발생했습니다.' }));
          throw new Error(errorData.message || '대체 텍스트 생성 실패');
        }

        const data = await response.json();
        if (!data.altText) {
          throw new Error('대체 텍스트 생성 실패');
        }

        return data.altText;
      }),
    );

    return results;
  } catch (error) {
    console.error('대체 텍스트 생성 중 오류 발생:', error);
    throw error;
  }
};
